import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';

import { routes } from './app.routes';
import { loadingInterceptor } from './interceptors/loading.interceptor';

import { AgGridModule } from 'ag-grid-angular';
import { apiErrorInterceptor } from './interceptors/api-error.interceptor';
import { MAT_DATE_LOCALE } from '@angular/material/core';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'ja-JP' },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([loadingInterceptor, apiErrorInterceptor])
    ),
    provideAnimations(),
    importProvidersFrom(AgGridModule)
  ]

};
